import React, { useCallback, useState } from 'react';
import {
  Input,
  Button,
  Container,
  Form,
  Label,
} from 'reactstrap';
import { useHistory } from 'react-router-dom';
import { useAuthenticationStatus } from '../../common/queries/useAuthenticationStatus';

/** The login page component */
export const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const authenticationStatusQuery = useAuthenticationStatus();

  const history = useHistory();

  const handleSubmit = useCallback(async (event) => {
    event.preventDefault();
    await fetch('api/account/login', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ username, password }) });
    authenticationStatusQuery.refetch();
    history.push('/');
  }, [authenticationStatusQuery, history, password, username]);

  return (
    <Container>
      <Form onSubmit={handleSubmit}>
        <h1 id="tabelLabel" className="mb-5">Aanmelden</h1>
        <div className="form-outline mb-4">
          <Label for="username">Gebruikersnaam</Label>
          <Input data-ta="username" id="username" value={username} onChange={e => { setUsername(e.target.value); }} />
        </div>

        <div className="form-outline mb-4">
          <Label for="password">Wachtwoord</Label>
          <Input data-ta="password" type="password" id="password" value={password} onChange={e => { setPassword(e.target.value); }} />
        </div>
        <Button data-ta="login-button">Aanmelden</Button>
      </Form>
    </Container>
  );
};
